import { FC, MouseEvent, ReactNode, useMemo } from 'react';
import styled from 'styled-components';
import { Avatar, AvatarProps, Badge } from '@mui/material';

const StyledBadge = styled(Badge)<{ $available?: boolean }>`
  height: fit-content;

  .MuiBadge-badge {
    outline: 1px solid white;
    background-color: ${({ $available, theme }) =>
      $available ? theme.palette.success.dark : theme.palette.grey['400']};
  }
`;

type Props = {
  hasStatusIndicator?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  imageSrc?: string;
  fallbackCharacter?: string;
  isOnline?: boolean;
  color?: string;
  noPadding?: boolean;
  icon?: ReactNode;
  large?: boolean;
  variant?: AvatarProps['variant'];
};

const UserAvatar: FC<Props> = ({
  hasStatusIndicator,
  imageSrc,
  fallbackCharacter,
  isOnline,
  color,
  icon = undefined,
  large,
  variant = 'circular',
}) => {
  const content = useMemo(() => {
    if (icon) return icon;
    if (fallbackCharacter) return fallbackCharacter;
    return undefined;
  }, [fallbackCharacter, icon]);

  return (
    <StyledBadge
      $available={isOnline}
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      variant="dot"
      invisible={!hasStatusIndicator}
    >
      <Avatar
        src={imageSrc}
        sx={{
          width: large ? 70 : 32,
          height: large ? 70 : 32,
          background: color,
        }}
        variant={variant}
      >
        {content}
      </Avatar>
    </StyledBadge>
  );
};

export default UserAvatar;
